'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

var _request = require('../../common/request');

var _request2 = _interopRequireDefault(_request);

var _config = require('../../common/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// declare let fastspring:any;
// declare let userEmail:any;
var purchase = /** @class */function () {
    function purchase() {
        this.Timer = null;
        // this.purchaseDom = document.getElementById("purchase-box")!;
        this.headerDom = document.getElementById('kingshiper-header');
        this.purchaseDom = document.getElementById("buy-box");
        this.paySuccessDom = document.getElementById("payment-success");
        this.payFailDom = document.getElementById("payment-fail");
        this.maskDom = document.getElementById("payment-mask");
        this.wmRequest = new _request2.default();
        this.init();
    }
    purchase.prototype.init = function () {
        this.bindBuyEvent();
        // this.bindSuccessReturnEvent();
        // this.bindFailReturnEvent();
    };
    purchase.prototype.bindBuyEvent = function () {
        var that = this;
        var buyBtns = _tool2.default.$_selectAll(this.purchaseDom, '.item-buyBtn');
        // let linkA = document.querySelector("#link-btn") as HTMLElement;
        buyBtns.forEach(function (buyBtn) {
            buyBtn.addEventListener("click", function () {
                if (isLogin == 1) {
                    // 在已登录的情况下，
                    var loadingDom_1 = buyBtn.querySelector(".loading");
                    loadingDom_1.style.opacity = "1";
                    // 在已登录的情况下，获取version_information的值给Option带出去
                    var version_information_value_1 = '';
                    var splitUrl = location.href.split('&');
                    splitUrl.forEach(function (item) {
                        if (item.includes('version_information')) {
                            version_information_value_1 = item.split('=')[1];
                        }
                    });
                    that.wmRequest.ajax({
                        url: _config2.default.WM_PURCHASE,
                        type: 'POST',
                        data: {
                            package_id: buyBtn.getAttribute('data-id'),
                            version_information: version_information_value_1
                        },
                        timeout: 20000
                    }).then(function (res) {
                        if (res.code == 200) {
                            loadingDom_1.style.opacity = "0";
                            location.href = res.data.link;
                            // linkA.setAttribute("href", res.data.link);
                            // linkA.click();
                        }
                    });
                    // let buyOption = {
                    //   'reset':true,
                    //   'products' : [
                    //     {
                    //       'path':buyBtn.getAttribute('path'),
                    //     },
                    //   ],
                    //   "paymentContact": {
                    //     "email": userEmail,
                    //   },
                    //   'checkout': true,
                    // }
                    // fastspring.builder.push(buyOption,function(){
                    //   // let popupCanvas = document.getElementById('fscCanvas')!;
                    //   // setTimeout(function(){
                    //   //   let popupIframe = document.getElementById('fsc-popup-frame')! as HTMLIFrameElement;
                    //   //   console.log(popupIframe);
                    //   //   popupIframe.onload = function(){
                    //   //   }
                    //   // },200)
                    // });
                } else {
                    var hasLoginBtn = document.body.contains(document.getElementsByClassName('kingshiper-header-right-no-login')[0]);
                    if (hasLoginBtn) {
                        var btn = _tool2.default.$_select(that.headerDom, '.kingshiper-header-right-no-login');
                        btn.click();
                    }
                }
            });
        });
        // 支付成功后会产生数据
        window.dataPopupClosed = function (data) {
            // 支付成功
            if (data !== null && data.reference !== null) {
                var productParams = window.location.pathname.split("/")[1];
                window.location.href = "/".concat(productParams, "/help.html");
            } else if (data != null && (data.id == null || data.reference == null)) {
                // 支付失败
            } else {
                that.maskDom.style.display = 'none';
            }
        };
        // (window as any).dataPopupWebhookReceived = function(data:any){
        // }
    };
    purchase.prototype.bindSuccessReturnEvent = function () {
        var that = this;
        var paySuccessReturn = _tool2.default.$_select(this.paySuccessDom, '.return-btn');
        var returnDomNum = _tool2.default.$_select(this.paySuccessDom, '.return-btn span');
        paySuccessReturn.addEventListener('click', function () {
            that.maskDom.style.display = 'none';
            that.paySuccessDom.style.display = 'none';
            returnDomNum.innerHTML = '';
            // let productParams = window.location.pathname.split("/")[1];
            // window.location.href = `/${productParams}/help.html`;
            window.location.href = '/user#order';
        });
    };
    purchase.prototype.bindFailReturnEvent = function () {
        var that = this;
        var payFailReturn = _tool2.default.$_select(this.payFailDom, '.return-btn');
        var returnDomNum = _tool2.default.$_select(this.payFailDom, '.return-btn span');
        payFailReturn.addEventListener('click', function () {
            that.payFailDom.style.display = 'none';
            that.maskDom.style.display = 'none';
            returnDomNum.innerHTML = '';
        });
    };
    purchase.prototype.disCountEvent = function (container) {
        var that = this;
        var returnDomNum = _tool2.default.$_select(container, '.return-btn span');
        var returnBtn = _tool2.default.$_select(container, '.return-btn');
        var num = 3;
        returnDomNum.innerHTML = "(".concat(num.toString(), ")");
        if (this.Timer) {
            clearInterval(Number(this.Timer));
        }
        this.Timer = setInterval(function () {
            num--;
            returnDomNum.innerHTML = "(".concat(num.toString(), ")");
            if (num < 0) {
                clearInterval(Number(that.Timer));
                returnDomNum.innerHTML = '';
                returnBtn.click();
            }
        }, 1000);
    };
    return purchase;
}();
exports.default = purchase;